import { useRouter } from 'vue-router';
import { isAppUrl } from '@/app/util/markdown.js';

// Rendered markdown holds plain anchors, so a link into the app would reload the page and lose the chat.
export default function useMarkdownAppLinks() {
  const router = useRouter();

  function routeAppLink(event) {
    const anchor = event.target.closest('a');
    if (!anchor) return;
    const href = anchor.getAttribute('href');
    if (!href || anchor.getAttribute('target') === '_blank') return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    let url;
    try {
      url = new URL(href, window.location.href);
    } catch {
      return;
    }
    if (!isAppUrl(url)) return;

    const path = url.pathname + url.search + url.hash;
    if (!isInProfileArea(router.resolve(path))) return;

    event.preventDefault();
    router.push(path);
  }

  // A link into another profile area, such as /customer/ from the employee app, needs the full load that sets
  // up that profile.
  function isInProfileArea(route) {
    const route_current = router.currentRoute.value;
    return (
      route.matched[0].path === route_current.matched[0].path &&
      route.params.subdomain === route_current.params.subdomain
    );
  }

  return { routeAppLink };
}
